import {useNavigate} from "react-router-dom";
import SaveBundleCreateJourneyDialogue
    from "../../../components/save-bundle-create-journey-dialogue/SaveBundleCreateJourneyDialogue";
import {createJourney, CreateJourneyProps} from "../../../redux/reducer/journey";
import {PATH_STRINGS} from "../../../routes/route-props";
import {useAppDispatch, useAppSelector} from "../../../redux/reducer/store";
import React, {useState} from "react";
import {VALIDATE_FORM_STARTING_NUMBER} from "../../../constants/default-values";
import {Text} from "atmosfair-ui"
import "./styles.css"
import BottomButtons from "../../../components/button-groups/bottom-buttons/BottomButtons";
import TopButtonsWrapper from "../../../components/button-groups/top-buttons-wrapper/TopButtonsWrapper";
import LoadBundlesButton from "../../../container/buttons/load-bundles-button/LoadBundlesButton";
import {BundleType} from "../../../container/buttons/common";

const CreateJourney = () => {
    const {agencies} = useAppSelector(state => state.user)
    const [validateCreateJourneyForm, setValidateCreateJourneyForm] = useState(VALIDATE_FORM_STARTING_NUMBER)
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    return <>
        <TopButtonsWrapper
            rightButtons={<LoadBundlesButton
                showBundleIcon={false}
                whatToLoad={BundleType.journey}/>}/>
        <div
            onKeyDown={event => {
                if (event.key === "Enter") {
                    event.preventDefault()
                    setValidateCreateJourneyForm(validateCreateJourneyForm + 1)
                }
            }}
            className={"create-journey-container"}>
            {
                agencies ? <SaveBundleCreateJourneyDialogue
                        defaultValues={null}
                        persistJourneyInBackend={false}
                        persistTravelComponentsInBackend={false}
                        createJourneyFromTravelComponents={true}
                        showCompany={false}
                        hideTravelComponents={true}
                        onFormIsValid={data => {
                            dispatch(createJourney(data as CreateJourneyProps))
                            navigate(PATH_STRINGS.journey)
                        }}
                        validateForm={validateCreateJourneyForm}
                        agencies={agencies}
                        activities={[]}
                    /> :
                    <Text>SCREENS.CREATE_JOURNEY.NO_AGENCY</Text>
            }
        </div>
        <BottomButtons buttons={[
            {
                text: "GENERAL.ABORT",
                variant: "abort",
                onClick: () => navigate(-1)
            },
            {
                text: "GENERAL.CREATE_JOURNEY",
                onClick: () => setValidateCreateJourneyForm(validateCreateJourneyForm + 1)
            }]}/>
    </>
}

export default CreateJourney